import script from "./PersonnelInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonnelInfoView.vue?vue&type=script&setup=true&lang=js"

import "./PersonnelInfoView.vue?vue&type=style&index=0&id=79f10f1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f10f1f"]])

export default __exports__